import { AppShell, Group, Title, Text } from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import { useUser } from '@clerk/clerk-react'
import { ThemeSwitcher, UserMenu, HamburgerMenu } from './'
import { ProtectedAction } from '../auth'
import { useState, useEffect } from 'react'

export function AppHeader() {
    const navigate = useNavigate()
    const { isSignedIn } = useUser()
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768)
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <AppShell.Header px="md" py="sm">
            <Group justify="space-between" align="center" h="100%" wrap="nowrap">
                <Group gap={isMobile ? "xs" : "md"} style={{ minWidth: 0, flex: 1 }}>
                    <HamburgerMenu />
                    <div
                        style={{ minWidth: 0, cursor: 'pointer' }}
                        onClick={() => navigate('/')}
                    >
                        <Title order={1} size={isMobile ? "h3" : "h2"} mb={-4}>Spotter</Title>
                        <Text size="xs" mt={6} c="dimmed" fw={500}>v0.70</Text>
                    </div>
                </Group>
                <Group gap={isMobile ? "xs" : "sm"} style={{ flexShrink: 0 }}>
                    <ThemeSwitcher />
                    {isSignedIn ? (
                        <UserMenu />
                    ) : (
                        <ProtectedAction
                            fallbackText="Sign In"
                            fallbackIcon={undefined}
                            fallbackVariant="filled"
                            fallbackSize="sm"
                            fallbackFullWidth={false}
                            fallbackColor="secondary"
                        >
                            <div />
                        </ProtectedAction>
                    )}
                </Group>
            </Group>
        </AppShell.Header>
    )
} 